import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';
import {VisionStep} from '../../vision/message/VisionStep';

export class Milestone extends BasicEntity {
code: string;
date: number | null;
description: TranslatedEmb;
label: TranslatedEmb;
visionSteps: VisionStep[];
}

